import React from "react";
import { palettes, spacers } from "@trainline/depot-web/css";
const Dot = ({ style, ...props }) => /* @__PURE__ */ React.createElement("span", {
  style: {
    width: "4px",
    height: "4px",
    borderRadius: "100%",
    backgroundColor: palettes.dp_brand_neutral_bright,
    ...style
  },
  ...props
});
const IconConnectionLeg = () => /* @__PURE__ */ React.createElement("span", {
  style: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: spacers.dp_s4
  }
}, /* @__PURE__ */ React.createElement(Dot, null), /* @__PURE__ */ React.createElement(Dot, null), /* @__PURE__ */ React.createElement(Dot, null), /* @__PURE__ */ React.createElement("svg", {
  width: "32",
  height: "32",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  style: { margin: "-6px 0" }
}, /* @__PURE__ */ React.createElement("path", {
  d: "M8.75 6.25c.345 0 .625.28.625.625v6.25c0 .345-.28.625-.625.625s-.625-.28-.625-.625v-2.498l-6.875-.002c-.345 0-.625-.28-.625-.625s.28-.625.625-.625l6.875.002V6.875c0-.345.28-.625.625-.625zm2.5 0c.345 0 .625.28.625.625v2.5l6.875.003c.345 0 .625.28.625.625s-.28.625-.625.625l-6.875-.004v2.501c0 .345-.28.625-.625.625s-.625-.28-.625-.625v-6.25c0-.345.28-.625.625-.625z",
  fill: palettes.dp_brand_neutral_dim
})), /* @__PURE__ */ React.createElement(Dot, null), /* @__PURE__ */ React.createElement(Dot, null), /* @__PURE__ */ React.createElement(Dot, {
  style: { opacity: 0 }
}));
var IconConnectionLeg_default = IconConnectionLeg;
export {
  IconConnectionLeg_default as default
};
